import { render } from "./v-select.vue?vue&type=template&id=56cf4c7e&lang=true"
import script from "./v-select.vue?vue&type=script&lang=js"
export * from "./v-select.vue?vue&type=script&lang=js"

import "./v-select.vue?vue&type=style&index=0&id=56cf4c7e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__